import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findShipmentProductList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/productList?` + params,
        method: 'GET'
    })
}
export const findShipmentProductList2 = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/productList2?` + params,
        method: 'GET'
    })
}
export const findShipmentProductList2DownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/productList2Excel?` + params,
        method: 'GET'
    })
}
export const productDetail = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/productDetail?` + params,
        method: 'GET'
    })
}
export const productDetail2 = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/productDetail2?` + params,
        method: 'GET'
    })
}
export const productDetail2Excel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/shipment/productDetail2Excel?` + params,
        method: 'GET'
    })
}